/**
 * Central permission helper — pure functions operating on a permission array.
 * The array comes from /users/me/permissions (or /auth/me → permissions).
 *
 * Wildcards:
 *   - '*'         grants everything (admin)
 *   - 'module.*'  grants all actions on a module (e.g. 'dealers.*')
 */

export function hasPermission(perms, key) {
  if (!key) return true;
  if (!Array.isArray(perms) || perms.length === 0) return false;
  if (perms.includes("*")) return true;
  if (perms.includes(key)) return true;
  const module = String(key).split(".")[0];
  return perms.includes(`${module}.*`);
}

export function hasAnyPermission(perms, keys) {
  if (!keys || keys.length === 0) return true;
  return keys.some((k) => hasPermission(perms, k));
}

export function hasAllPermissions(perms, keys) {
  if (!keys || keys.length === 0) return true;
  return keys.every((k) => hasPermission(perms, k));
}
